import { store } from '../../../redux/store';
import { ScheduleImpactRequestActions } from '../../../redux/actions/scheduleImpactRequestActions';

export const resetStatusScheduleImpactRequest = (action, status) => {
  const dispatch = store.dispatch;

  const { scheduleImpactRequestState } = store.getState();
  const { scheduleImpactRequestItems } = scheduleImpactRequestState;

  action?.commands?.map((item) => {
    if (item.entity === 'task' && item.type === 'remove') {
      const { oldValue } = item;

      if (!oldValue) {
        return;
      }

      if (oldValue?.pendingRequests?.length > 0) {
        const currentScheduleImpactRequestItem =
          scheduleImpactRequestItems.find(
            (item) => item?.id === oldValue?.pendingRequests?.[0]?.id
          );

        if (currentScheduleImpactRequestItem) {
          dispatch(
            ScheduleImpactRequestActions.setScheduleImpactRequestItem({
              ...currentScheduleImpactRequestItem,
              state: status,
              status: status,
              date: new Date()
            })
          );
        }
      }
    }
  });
};
